module.exports = __webpack_public_path__ + "bc8c522b6ec0cd5b4fe353531b2e6990.png";